<template>
  <div id="loginClient">
    <div>
      <slot></slot>
    </div>
    <!-- <div class="footer">
      <div class="footer_top">
        <div class="inner">
          <div class="main_row">
            <div class="col_box col_box1">
              <div class="col_title">
                <router-link to="/home">
                  <img alt />
                </router-link>
              </div>
              <div class="col_content">
                <ul v-html="$t('loginClient.baseOthers', { platformUrl: platformUrl })"></ul>
              </div>
            </div>
            <div class="col_box col_box2">
              <div class="col_title">
                <h2 class="text_color" v-html="$t('loginClient.ContactUs')"></h2>
              </div>
              <div class="col_content">
                <ul>
                  <li>
                    <div v-html="address" class="vhtml"></div>
                  </li>
                  <li>
                    <img src="@/assets/images/login/footer_email_icon.png" alt />
                    <a :href="'mailto:' + email">{{ email }}</a>
                  </li>
                  <li @click="showLiveChat" class="liveChat">
                    <img src="@/assets/images/login/footer_chat_icon.png" alt />
                    <span>Live Chat</span>
                  </li>
                </ul>
              </div>
            </div>
            <div class="col_box col_box3">
              <div class="col_title">
                <h2 class="text_color" v-html="$t('loginClient.FundingMethods')"></h2>
              </div>
              <div class="col_content">
                <div class="link_img">
                  <img src="@/assets/images/login/footer_img1.png" alt />
                  <img src="@/assets/images/login/footer_img2.png" alt />
                  <img src="@/assets/images/login/footer_img3.png" alt />
                  <img src="@/assets/images/login/footer_img7.png" alt />
                  <img src="@/assets/images/login/footer_img9.png" alt />
                  <img src="@/assets/images/login/footer_img10.png" alt />
                </div>
              </div>
            </div>
          </div>
          <div class="link_row">
            <ul>
              <li>
                <a :href="`https://${platformUrl}/company/regulation/legal-document/`">Legal Documents</a>
              </li>
              <li>
                <a :href="`https://${platformUrl}/files/VT_Markets_LLC_Privacy_Policy.pdf`">Client Agreement</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="footer_bottom">
        <div class="inner">
          <ul>
            <li>
              <strong>{{ $t('loginClient.riskWarn') }}</strong>
              <p>{{ $t('loginClient.riskWarndesc') }}</p>
            </li>
            <li>
              <strong>{{ $t('loginClient.generalWarn') }}</strong>
              <p>{{ $t('loginClient.generalWarndesc') }}</p>
            </li>
            <li>
              <strong>{{ $t('loginClient.regionRes') }}</strong>
              <p>{{ $t('loginClient.regionResdesc') }}</p>
            </li>
          </ul>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      email: this.$config.info.getEmail('cima'),
      address: this.$config.info.getLoginAddress('cima'),
      url: this.$config.info.getUrl('cima'),
      platformUrl: this.$config.info.getUrl('cima')
    };
  }
};
</script>

<style lang="scss">
@import '@/assets/css/pages/login.scss';
</style>
